import React, { Fragment, useState, useEffect } from 'react';
import CardMainPost from './CardMainPost';
import { Container } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { dateToShow } from "../../dateToShow";
import env from '../../environments/Api';


const root = env('posts').api.globalRoute;

function ShowPostList(props) {

    const [reactions, setReactions] = useState([]);
    const [charge, setCharged] = useState(false);

    useEffect(() =>  {
     fetch(`${root}/reacciones`)
        .then(res => (res.ok ? res : Promise.reject(res)))
        .then(res => res.json())
        .then(res => { setReactions(res); setCharged(true);})
    }, []);

    return (
        <Fragment style={{ background: 'transparent' }}>
            <Container justify="center"
                alignItems="center"
                style={{ background: 'transparent' }}
            >
                <br />
                <br />
                {props.listPost.map((post) => {
                    return <Box key={post.id_post} p={1} style={{ background: 'transparent' }}>
                        <div id={post.id_post} class="post" style={{ background: 'transparent' }}
                        >
                            <CardMainPost
                                key={post.idPost}
                                userId={props.userId}
                                userName={props.userName}
                                idOwnerPost={post.id_colaborador}
                                idPost={post.id_post}
                                name={post.nombre_colaborador}
                                date={dateToShow(post.diferencia_tiempo_minutos)}
                                comment={post.descripcion}
                                quantityComment={post.cantidad_comentarios}
                                congratUser={post.colaborarador_felicitado}
                                typeRecognition={post.nombre_reconocimiento}
                                imageUrl={post.imagen_url_post}
                                avatarUrl={post.imagen_url_perfil}
                                reactions={reactions}
                                listReactions={post.lista_reacciones}
                            />
                        </div>
                    </Box>
                })}
            </Container>
        </Fragment>
    );
}

export default ShowPostList;